import { render } from "./IsoHospital.vue?vue&type=template&id=98db3d88&scoped=true"
import script from "./IsoHospital.vue?vue&type=script&lang=js"
export * from "./IsoHospital.vue?vue&type=script&lang=js"

import "./IsoHospital.vue?vue&type=style&index=0&id=98db3d88&scoped=true&lang=css"
import "./IsoHospital.vue?vue&type=style&index=1&id=98db3d88&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98db3d88"]])

export default __exports__